/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
/* eslint-disable react/jsx-props-no-spreading */
import _ from 'lodash';
import io from 'socket.io-client';
import React from 'react';
import Qrcode from 'qrcode';
// import { uuid } from 'components/functions';
import { useQueryClient } from 'react-query';
import { Button, Upload, message, Tooltip, Space, Modal } from 'antd';
import { InfoCircleOutlined, UploadOutlined } from '@ant-design/icons';

import { sachsoServerUrl, socketServerUrl, websiteUrl } from 'constants/serverUrls';
import colors from 'constants/colors';
import { Col, Row } from 'reactstrap';
import withAuthenticator from 'HOCs/withAuthenticator';
import { APPLICATION_NAME } from 'constants/settings';

type Props = {
  entityId: string;
  entityName: string;
  moduleName?: string;
  subModuleName: string;
  maxCount?: number;
  onSuccess: (value: boolean) => void;
  showQrCode?: boolean;
  loggedInUser: any;
};

// SOCKET.IO
const socket = io(socketServerUrl, {
  secure: true,
  reconnection: true,
  reconnectionDelay: 5000,
  reconnectionAttempts: 20,
  // transports: ['polling'],
});

const UploadFiles = ({ entityId, entityName, moduleName, subModuleName, showQrCode, maxCount = 5, onSuccess, loggedInUser }: Props) => {
  const queryClient = useQueryClient();
  const key = [`t_${moduleName}_${subModuleName}_${entityName}`, entityId];

  const [qrcodeImageUrl, setQrcodeImageUrl] = React.useState('');
  const [modalVisible, setModalVisible] = React.useState(false);

  const [fileList, setFileList] = React.useState([]);

  const uploadSettings = {
    name: 'files',
    action: `${sachsoServerUrl}/api/v1.0/dynamic/upload-files`,
    headers: {
      Authorization: 'Basic 12C1F7EF9AC8E288FBC2177B7F54D',
      ApplicationName: APPLICATION_NAME,
    },
    data: { entityId, entityName, subModuleName, moduleName },
    fileList,
    maxCount,
    onChange(info: any) {
      setFileList(info.fileList);
      if (info.file.status === 'error') {
        message.error(`Tập tin ${info.file.name} tải lên bị lỗi.`);
      }

      // Check completed all.
      const isCompleted = _.every(info.fileList, { status: 'done' });
      if (isCompleted) {
        setFileList([]);
        message.success('Upload files: Hoàn thành.');

        socket.emit('send', { messageType: 'query', payload: { roomId: `t_SHARE_Attachments_${entityId}`.toUpperCase() } });

        if (onSuccess && typeof onSuccess === 'function') {
          onSuccess(isCompleted);
        }
      }
    },
  };

  React.useEffect(() => {
    if (showQrCode) {
      Qrcode.toDataURL(`${websiteUrl}/upload/qrcode/SACHSO/${subModuleName}/${entityName}/${entityId}`, (err: any, url: string) => {
        console.log(err);
        setQrcodeImageUrl(url);
      });
    }
  }, [entityId, entityName, showQrCode, subModuleName]);

  React.useEffect(() => {
    socket.on('server-message', (data) => {
      switch (data.messageType) {
        case 'query':
          queryClient.invalidateQueries(key);
          break;
        default:
          break;
      }
    });

    socket.on('connect', () => {
      console.log(`Socket is connected with id: ${socket.id}`);
      socket.emit('send', { messageType: 'join-room', payload: { roomId: `t_SHARE_Attachments_${entityId}`.toUpperCase() } });
    });

    socket.on('disconnect', () => {
      console.log('Socket is disconnected');
    });

    // Join room

    // return () => {
    //   socket.disconnect();
    // };
  }, [entityId, queryClient]);

  return (
    <React.Fragment>
      {entityId && (
        <React.Fragment>
          <Row>
            <Col sm='12' md='6' lg='4'>
              <Upload multiple {...uploadSettings}>
                <Space>
                  <Tooltip title='Upload files'>
                    <Button type='primary' icon={<UploadOutlined />}>
                      Tải lên
                    </Button>
                  </Tooltip>
                  <span style={{ fontWeight: 400 }}>(Chọn tối đa 5 tập tin)</span>
                </Space>
              </Upload>
            </Col>
            {/* {loggedInUser?.role === 'teacher' && (
              <Col sm='12' md='6' lg='4'>
                <div className='mt-3 mt-md-0'>
                  <span>Bài tập worksheet: </span>
                  <Tooltip title='Bài tập WorkSheet'>
                    <Button
                      onClick={() => {
                        localStorage.removeItem('currentWorkSheetId');
                        window.open(`/lms/teacher/worksheet/${entityId}`);
                      }}
                      // onClick={() => window.open(`/lms/teacher/worksheet/${'358d8538-628d-471e-8ed5-5c337f4aa8cb'}`)}
                      type='primary'
                    >
                      Tạo bài tập
                    </Button>
                  </Tooltip>
                </div>
              </Col>
            )} */}
          </Row>
          {showQrCode && qrcodeImageUrl && (
            <div style={{ marginBlock: 12 }}>
              <Space direction='vertical'>
                <Space>
                  <InfoCircleOutlined />
                  <em>Mẹo: Bạn có thể dùng điện thoại</em>

                  <Button
                    type='dashed'
                    onClick={() => {
                      setModalVisible(true);
                    }}
                  >
                    <span style={{ color: colors.primary, fontWeight: 600 }}>QUÉT MÃ QRCODE</span>
                  </Button>
                  <em>để tải lên các tập tin từ điện thoại.</em>
                </Space>
              </Space>
            </div>
          )}
        </React.Fragment>
      )}

      <Modal
        centered
        title='Bật camera trên điện thoại để quét mã QRCODE'
        visible={modalVisible}
        footer={null}
        onCancel={() => {
          setModalVisible(false);
        }}
      >
        <div>
          <a href={`${websiteUrl}/upload/qrcode/SACHSO/${subModuleName}/${entityName}/${entityId}`} target='_blank' rel='noreferrer'>
            <img src={qrcodeImageUrl} alt='QRCODE' style={{ width: '100%' }} />
          </a>
        </div>
      </Modal>
    </React.Fragment>
  );
};

UploadFiles.defaultProps = {
  maxCount: 5,
  showQrCode: true,
  moduleName: 'SACHSO',
};

export default withAuthenticator(UploadFiles);
